import { Component, OnInit } from "@angular/core";
import { AutotextService } from "src/app/autotext.service";
import { ExamsService } from "src/app/exams.service";
import { GastroFormsService } from "src/app/gastro-forms.service";
import { UsgService } from "src/app/usg.service";
import { LoginService } from "src/app/login.service";
import { MedicationService } from "src/app/medication.service";
import { PatientsService } from "src/app/patients.service";
import { AngularEditorConfig } from "@kolkov/angular-editor";

@Component({
    selector: "app-abdomenus",
    templateUrl: "./abdomenus.component.html",
    styleUrls: ["./abdomenus.component.scss"],
    standalone: false
})
export class AbdomenusComponent implements OnInit {
  editorConfig: AngularEditorConfig = {
    editable: true,
    height: "fit-contnet",
    toolbarHiddenButtons: [
      ["subscript", "superscript", "strikeThrough"],
      [
        "backgroundColor",
        "customClasses",
        "link",
        "unlink",
        "insertImage",
        "insertVideo",
        "removeFormat",
        "toggleEditorMode",
      ],
    ],
  };

  constructor(
    public ls: LoginService,
    public gs: UsgService,
    public es: ExamsService,
    public atS: AutotextService,
    public medS: MedicationService,
    public gfs: GastroFormsService,
    private patService: PatientsService
  ) {}

  ngOnInit(): void {}

  // AR-24 change 3: AI medical-history summary from the patient's answered questionnaire.
  aiSummaryLoading = false;
  getAiSummary() {
    if (this.aiSummaryLoading) return;
    this.aiSummaryLoading = true;
    this.es.getAiSummary(this.es.ExamType, this.patService.getPat()?.PID).subscribe(
      (res: any) => {
        this.aiSummaryLoading = false;
        if (res && res.summary) {
          const control = this.gs.gastroForm?.get('MedicalHistory');
          if (control) {
            const existing = (control.value || '').toString().trim();
            const previous = (res.previousSummary || '').toString().trim();
            // Replace only our own previously-pasted AI block (exact match), so a
            // doctor's hand-typed notes are never overwritten; otherwise append.
            if (previous && existing === previous) {
              control.setValue(res.summary);
            } else {
              control.setValue(existing ? existing + '\n\n' + res.summary : res.summary);
            }
          }
        } else if (res && res.reason) {
          alert('Could not generate a summary (' + res.reason + ').');
        }
      },
      () => {
        this.aiSummaryLoading = false;
      }
    );
  }
}
